var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeaterQ1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_2925",
    "data-name": "Groupe 2925",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.765,
    height: 38.782,
    viewBox: "0 0 38.765 38.782",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heater",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M23.408,38.064a2.584,2.584,0,0,1-.149-3.574v-1.12a2.241,2.241,0,0,1-.969.227,2.264,2.264,0,0,1-2.261-2.261v-.969H18.736v.969a2.261,2.261,0,0,1-4.523,0v-.969H12.921v.969a2.247,2.247,0,0,1-3.23,2.035v1.12a2.584,2.584,0,1,1-3.876,0v-1.12a2.241,2.241,0,0,1-.969.227,2.264,2.264,0,0,1-2.261-2.261V29.073A2.587,2.587,0,0,1,0,26.489V22.613a2.587,2.587,0,0,1,2.584-2.584V10.983A2.587,2.587,0,0,1,0,8.4V7.107A2.587,2.587,0,0,1,2.584,4.523V2.261a2.261,2.261,0,1,1,4.522,0V3.23H8.4V2.261a2.261,2.261,0,1,1,4.522,0V3.23h1.292V2.261a2.261,2.261,0,0,1,4.523,0V3.23h1.292V2.261a2.261,2.261,0,0,1,4.523,0V3.23h1.292V2.261a2.261,2.261,0,0,1,4.523,0v28.1H32.95a1.94,1.94,0,0,0,1.938-1.938v-3.3A3.236,3.236,0,0,1,32.3,21.966V20.674A1.294,1.294,0,0,1,33.6,19.382v-3.23a.646.646,0,0,1,1.292,0v3.23H36.18v-3.23a.646.646,0,0,1,1.292,0v3.23a1.294,1.294,0,0,1,1.292,1.292v1.292a3.236,3.236,0,0,1-2.584,3.165v3.3a3.235,3.235,0,0,1-3.23,3.23H30.333a2.236,2.236,0,0,1-3.2,1.712v1.12a2.584,2.584,0,0,1-3.727,3.574Z",
    transform: "translate(0)",
    fill: "#e1f4fb"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "flash",
    transform: "translate(10.777 10.694)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M8.271,5.124a.279.279,0,0,0-.242-.141H4.38L4.992.309A.28.28,0,0,0,4.478.127L.041,7.9a.279.279,0,0,0,.237.424H3.873l-.485,4.681a.28.28,0,0,0,.516.171L8.268,5.4a.279.279,0,0,0,0-.28Z",
    transform: "translate(0 0)",
    fill: "#00a3da"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaterQ1);
export default __webpack_public_path__ + "static/media/heater__Q1_.81f91b1b087984e4786cc070e96f92f6.svg";
export { ForwardRef as ReactComponent };